var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop",class:{'--open':_vm.state.isOpen},on:{"click":_vm.click,"mouseover":function($event){$event.preventDefault();return _vm.mouseover.apply(null, arguments)},"mouseleave":function($event){$event.preventDefault();return _vm.mouseleave.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }